import Alpine from "alpinejs"

Alpine.data("anchorNavigation", () => ({
    active: null,
    clickedSection: null,
    observer: null,

    init() {
        const sections = Array.from(document.querySelectorAll("[id]")).filter((el) =>
            this.$el.querySelector(`[href="#${el.id}"]`),
        )
        if (!sections.length) return

        this.setupClickHandling()

        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        if (!this.clickedSection) {
                            this.active = entry.target.id
                        }
                    }
                })
            },
            {
                threshold: 0.2, // section must be at least 50% visible
            },
        )

        sections.forEach((section) => this.observer.observe(section))
    },

    setupClickHandling() {
        const links = this.$el.querySelectorAll('a[href^="#"]')

        links.forEach((link) => {
            link.addEventListener("click", () => {
                const targetId = link.getAttribute("href").substring(1)
                const targetEl = document.getElementById(targetId)

                if (targetEl) {
                    this.active = targetId
                    this.clickedSection = targetId

                    setTimeout(() => {
                        this.clickedSection = null
                    }, 1000) // small grace period for scroll animation
                }
            })
        })
    },

    destroy() {
        if (this.observer) {
            this.observer.disconnect()
        }
    },
}))
